import { Box, Button, Menu, Stack } from "@mui/material"
import { useState } from "react"
import Iconify from "minimals-template/components/Iconify"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { VIEW_DRAFTS, VIEW_LIST, VIEW_UNMAPPED } from "../lib/library-views"
import { canReviewComponents } from "../lib/can-review-components"
import { LibraryViewOption } from "./library-view-option"

export function LibraryViewSelector({ view, onSelectView }) {
    const [anchorElement, setAnchorElement] = useState(null)
    const options = getViewOptions()

    return (
        <>
            <Stack
                alignItems="center"
                direction="row"
                spacing={1}
                sx={{
                    fontSize: "85%",
                    lineHeight: 1,
                    mt: 0.2,
                    color: "text.primary",
                }}
            >
                <Box sx={{ fontWeight: "bold" }}>View:</Box>
                <Button
                    data-cy="library-view-selector"
                    endIcon={<Iconify icon="mdi:arrow-down-drop" />}
                    onClick={handleOpen}
                    sx={{
                        color: "text.primary",
                        fontSize: "inherit",
                        fontWeight: "normal",
                        lineHeight: "inherit",
                        minWidth: 0,
                        p: 0,
                        textTransform: "none",
                        "&:hover": {
                            bgcolor: "transparent",
                        },
                    }}
                    variant="text"
                >
                    {getViewModeName()}
                </Button>
            </Stack>
            <Menu onClose={handleClose} open={Boolean(anchorElement)} anchorEl={anchorElement}>
                <Bound selectedView={view} onSelectOption={handleSelectOption}>
                    <Repeat list={options} item={<LibraryViewOption />} keyFn="value" />
                </Bound>
            </Menu>
        </>
    )

    function getViewOptions() {
        const list = [
            { value: VIEW_LIST, label: "Library", dataCy: "library-view-option-library" },
            { value: VIEW_UNMAPPED, label: "Unmapped Documents", dataCy: "library-view-option-unmapped" },
        ]

        if (canReviewComponents()) {
            list.push({ value: VIEW_DRAFTS, label: "Drafts", dataCy: "library-view-option-drafts" })
        }

        return list
    }

    function handleOpen(event) {
        setAnchorElement(event.currentTarget)
    }

    function handleClose() {
        setAnchorElement(null)
    }

    function handleSelectOption(value) {
        handleClose()
        onSelectView?.(value)
    }

    function getViewModeName() {
        return options.find(isCurrentView)?.label ?? "Library"
    }

    function isCurrentView(option) {
        return option.value === view
    }
}
